var _rect, _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackButton = function SvgBackButton(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.25,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#F5F5FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9506 16L19.5959 10.3546C20.1346 9.81598 20.1346 8.94264 19.5959 8.40399C19.0573 7.86534 18.1839 7.86534 17.6453 8.40399L11.0246 15.0247C10.4859 15.5633 10.4859 16.4367 11.0246 16.9753L17.6453 23.596C18.1839 24.1347 19.0573 24.1347 19.5959 23.596C20.1346 23.0574 20.1346 22.184 19.5959 21.6454L13.9506 16Z",
    fill: "#5656FC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackButton, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backButton.c089954e.svg";
export { ForwardRef as ReactComponent };